import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function Prompt({
  isOpen = false,
  title = "",
  placeholder = "",
  text = "",
  field = {},
  onClose,
  onSubmit,
  cancelTitle = "Cancelar",
  submitTitle = "Ok",
}) {
  const [value, setValue] = useState(placeholder);

  useEffect(() => {
    setValue(placeholder || "");
  }, [placeholder]);

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
        fullscreen
      >
        {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          {text && <DialogContentText>{text}</DialogContentText>}
          {field && (
            <TextField
              autoFocus
              margin="dense"
              id="prompt"
              label={field.label}
              type={field.type}
              value={value}
              onChange={({ target }) => setValue(target.value)}
              fullWidth
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {cancelTitle}
          </Button>
          <Button onClick={() => onSubmit(value)} color="primary">
            {submitTitle}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
